import { Tooltip, type TooltipProps } from '@mui/material';
import React, { useRef, useState } from 'react';

type OverflowTooltipProps = {
  title: React.ReactNode;
  children: React.ReactElement;
} & Omit<TooltipProps, 'title' | 'children'>;

export const OverflowTooltip = ({ title, children, ...tooltipProps }: OverflowTooltipProps) => {
  const [isOverflow, setIsOverflow] = useState<boolean>(false);
  const ref = useRef<HTMLElement>(null);

  const checkOverflow = () => {
    const element = ref.current;
    if (!element) return;

    const isContentOverflowing =
      element.clientWidth < element.scrollWidth || element.clientHeight < element.scrollHeight;

    if (isContentOverflowing !== isOverflow) setIsOverflow(isContentOverflowing);
  };

  const contentElement = React.cloneElement(children, {
    ref,
    onMouseEnter: checkOverflow,
    onFocus: checkOverflow,
  });

  return isOverflow ? (
    <Tooltip title={title} {...tooltipProps}>
      {contentElement}
    </Tooltip>
  ) : (
    contentElement
  );
};
